import {AfterViewInit, Component, EventEmitter, Inject, OnInit, Output, ViewChild} from '@angular/core';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {WeeeSystems} from '../../../models/weee_systems.interface';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {WeeeSystemService} from '../../../services/weee-system.service';
import {Countries} from '../../../models/countries.interface';
import {appConfig} from '../../../../config/config';
import {PageRequest} from '../../../../shared/models/page-request.interface';
import {User} from '../../../../kf-data-entry/models/user.interface';

@Component({
  selector: 'app-edit-weee-system',
  templateUrl: './edit-weee-system.component.html',
  styleUrls: ['./edit-weee-system.component.scss']
})
export class EditWeeeSystemComponent implements OnInit, AfterViewInit {
  pageSizes = appConfig.pageSizes;
  pageSize = 5;
  totalElements!: number;
  users!: User[];
  displayedColumns: string[] = ['name', 'firstName', 'role.name'];
  private page: PageRequest = {page: 0, size: 5, sort: 'name', direction: 'asc'};

  weeeSystemEditForm = this.formBuilder.group({
    description: ['', Validators.required],
    chartPermission: ['', Validators.required],
    intelligenceChartPermission: [false, Validators.required],
    country: [Validators.required],
    member: [false]
  });

  get descriptionControl(): FormControl {
    return this.weeeSystemEditForm.get('description') as FormControl;
  }
  get chartPermissionControl(): FormControl {
    return this.weeeSystemEditForm.get('chartPermission') as FormControl;
  }
  get intelligenceChartPermissionControl(): FormControl {
    return this.weeeSystemEditForm.get('intelligenceChartPermission') as FormControl;
  }
  get countryControl(): FormControl {
    return this.weeeSystemEditForm.get('country') as FormControl;
  }
  get memberControl(): FormControl {
    return this.weeeSystemEditForm.get('member') as FormControl;
  }

  @Output()
  editEvent: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  @ViewChild(MatSort)
  sort!: MatSort;

  constructor(@Inject(MAT_DIALOG_DATA) public data: {weeeSystem: WeeeSystems, countries: Countries[]},
              private dialogRef: MatDialogRef<EditWeeeSystemComponent>,
              private readonly formBuilder: FormBuilder,
              private readonly weeeSystemService: WeeeSystemService) { }

  ngOnInit(): void {
    this.descriptionControl.setValue(this.data.weeeSystem.description);
    this.countryControl.setValue(this.data.weeeSystem.country.id);
    this.memberControl.setValue(this.data.weeeSystem.isMember);
    this.chartPermissionControl.setValue(this.data.weeeSystem.chartPermission);
    this.intelligenceChartPermissionControl.setValue(this.data.weeeSystem.intelligenceChartPermission);
    this.getWSUsers();
  }

  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe(() => this.onSortChange(this.sort.active, this.sort.direction));
  }

  onSortChange(active: string, direction: string): void {
    this.page = {page: 0, size: this.pageSize, sort: active, direction};
    this.getWSUsers();
  }

  onPageChange(event: PageEvent): void {
    this.page = {page: event.pageIndex, size: event.pageSize};
    this.getWSUsers();
  }

  sendEditionRequest(): void {
    const dto: WeeeSystems | null = this.getEditionRequest();
    if (dto) {
      this.weeeSystemService.editWeeeSystem(dto).subscribe(
        () => {
          this.editEvent.emit();
          this.closeDialog();
        },
        () => {
          this.closeDialog();
        }
      );
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  private getWSUsers(): void {
    if (this.data.weeeSystem.id) {
      this.weeeSystemService.getWeeeSystemUsers(this.data.weeeSystem.id, this.page).subscribe(
        (data) => {
          this.users = data.content;
          this.pageSize = data.size;
          this.totalElements = data.totalElements;
        }
      );
    }
  }

  private getEditionRequest(): WeeeSystems {
    let countrySelected: Countries = {
      code: '',
      name: '',
    };
    this.data.countries.forEach(country => {
      if (country.id === this.countryControl.value) {
        countrySelected = country;
      }
    });
    return {
      id: this.data.weeeSystem.id,
      status: this.data.weeeSystem.status,
      description: this.descriptionControl.value,
      chartPermission: this.chartPermissionControl.value,
      intelligenceChartPermission: this.intelligenceChartPermissionControl.value,
      country: this.countryControl.value === this.data.weeeSystem.country.id ?
        this.data.weeeSystem.country : countrySelected,
      isMember: this.memberControl.value
    };
  }

}
